import _ from 'lodash';
import shortid from 'shortid';

import { DroppableAreaEnum } from 'Pages/productionreportsetup/helpers/Constants';

export const getIdAndColIndex = ({ droppableId }) => {
  const [id, colIndex] = droppableId.split('-');

  return { id, colIndex };
};

export const sortOptions = (l, r) => {
  const descriptionL = l.Description.toUpperCase();
  const descriptionR = r.Description.toUpperCase();
  if (descriptionL === descriptionR) return 0;
  return descriptionL < descriptionR ? -1 : 1;
};

export const moveOption = ({
  headerOptions,
  reportSection,
  reportColumns,
  source,
  destination,
  draggableId,
}) => {
  const { id: srcId, colIndex: srcColIndex } = getIdAndColIndex(source);
  const { id: destId, colIndex: destColIndex } = getIdAndColIndex(destination);
  let error = null;
  const updatedHeaderOptions = { ...headerOptions };

  if (srcId === destId) {
    // Switch the items
    if (destId === DroppableAreaEnum.OptionsSection) {
      const updatedReportSectionOptions = [...headerOptions[reportSection]];
      const temp = updatedReportSectionOptions[source.index];
      updatedReportSectionOptions[source.index] =
        updatedReportSectionOptions[destination.index];
      updatedReportSectionOptions[destination.index] = temp;
      updatedHeaderOptions[reportSection] = updatedReportSectionOptions;

      return { updatedHeaderOptions };
    } else {
      // Handle moving between columns
      if (srcColIndex !== destColIndex) {
        const updatedReportColumns = { ...reportColumns };
        const updatedDestColumnOptions = [
          ...updatedReportColumns[reportSection][destColIndex],
        ];
        updatedDestColumnOptions.splice(
          destination.index,
          0,
          updatedReportColumns[reportSection][srcColIndex][source.index]
        );

        const updatedSrcColumnOptions = updatedReportColumns[reportSection][
          srcColIndex
        ].filter((x) => x.Id !== draggableId);

        updatedReportColumns[reportSection][
          srcColIndex
        ] = updatedSrcColumnOptions;
        updatedReportColumns[reportSection][
          destColIndex
        ] = updatedDestColumnOptions;

        return { updatedReportColumns };
      } else {
        // Changing order within the same column
        const updatedReportColumns = { ...reportColumns };
        updatedReportColumns[reportSection] = [
          ...updatedReportColumns[reportSection],
        ];
        const columnItems = [
          ...updatedReportColumns[reportSection][srcColIndex],
        ];
        const temp = columnItems[source.index];
        columnItems.splice(source.index, 1);
        columnItems.splice(destination.index, 0, temp);
        updatedReportColumns[reportSection][srcColIndex] = columnItems;

        return { updatedReportColumns };
      }
    }
  } else if (
    srcId === DroppableAreaEnum.ReportSection &&
    destId === DroppableAreaEnum.OptionsSection
  ) {
    // Adding option to report
    const column = reportColumns[reportSection][srcColIndex];
    const currentOption = column[source.index];

    if (currentOption.Required) {
      return { error: 'Option is required and cannot be removed.' };
    }

    const updatedReportSectionOptions = [...headerOptions[reportSection]];
    updatedReportSectionOptions.splice(destination.index, 0, currentOption);
    updatedHeaderOptions[reportSection] = updatedReportSectionOptions;

    const updatedReportColumns = { ...reportColumns };
    const updatedColumnOptions = reportColumns[reportSection][
      srcColIndex
    ].filter((x) => x.Id !== draggableId);
    updatedReportColumns[reportSection][srcColIndex] = updatedColumnOptions;

    return { updatedHeaderOptions, updatedReportColumns, error };
  } else {
    // Moving option to report section
    const updatedHeaderOptions = { ...headerOptions };
    const option = headerOptions[reportSection][source.index];
    updatedHeaderOptions[reportSection] = updatedHeaderOptions[reportSection]
      .filter((x) => x.Id !== draggableId);
    const updatedReportColumns = { ...reportColumns };

    const updatedReportColumnOptions = [...reportColumns[reportSection]];
    updatedReportColumns[reportSection] = updatedReportColumnOptions;
    updatedReportColumnOptions[destColIndex].splice(
      destination.index,
      0,
      option
    );
    return { updatedHeaderOptions, updatedReportColumns };
  }
};

export const getUnusedOptions = (initialOptions, currentReportColumns) => {
  const optionsUsedBySection = {};

  Object.keys(currentReportColumns).forEach((section) => {
    optionsUsedBySection[section] = {};

    const optionsUsed = _.flattenDeep(currentReportColumns[section]);
    optionsUsed.forEach((option) => {
      optionsUsedBySection[section][option.Description] = true;
    });
  });

  const unusedOptionsBySection = {};

  Object.keys(optionsUsedBySection).forEach((section) => {
    if (initialOptions[section]) {
      unusedOptionsBySection[section] = initialOptions[section]
        .filter((option) => !optionsUsedBySection[section][option.Description])
        .map((option) => ({ ...option, Id: shortid.generate() }))
        .sort(sortOptions);
    }
  });

  return unusedOptionsBySection;
};



// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/helpers/dnd.js